const getDefaultState = () => {
  return {
    files: [],
    file: {},
    loading: false,
    itemLoading: false,
    // filter: {
    //     email: '',
    //     phone: '',
    //     cpf: '',
    //     installation_number: ''
    // },
    fileItems: [],
    utility_file_id: null,
    fileItem: {},
  };
};

// initial state
const state = getDefaultState();

export default {
  getDefaultState,
  ...state,
};
